// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"_2jhgroPWeZuN2_vYOcU7fm","backToTopIcon":"_3o9jCxMaah1DnJX8mn4jA6"};